// this file added for individual by Bearer Web Developer
import React, { useEffect, useRef } from 'react';
import styles from './second.module.scss';
import { useAppState } from '../../../../states/app-state';
import { SigninSituation } from '../../../../states/signinState';
import { Button } from '@mui/material';

const Second: React.FC = () => {

    const appState = useAppState();
    const { signin, login } = appState;
    const second = useRef<null | any>(null);
    const enterCodeSituation =
        signin.situation === SigninSituation.EnterCodeForSignin || signin.situation === SigninSituation.EnterCodeForSignup;
    let setIntervalForSeconds: any = null;
    useEffect(() => {
        if (second?.current && enterCodeSituation) {
            setIntervalForSeconds = setInterval(async () => {
                const text = second?.current;
                if (text?.innerHTML === "00:00") {
                    clearInterval(setIntervalForSeconds);
                    try {
                        signin.setLoading(true);
                        const resetResult = await appState.signin.resetRecaptcha();
                        signin.setLoading(false);
                        if (resetResult) {
                            const beforeSituation = appState?.signin.situation;
                            const newSituation = beforeSituation === SigninSituation.EnterCodeForSignin ?
                                SigninSituation.CodeExpiredForSignin : SigninSituation.EnterCodeForSignup;
                            signin.setSituation(newSituation);
                            return;
                        }
                    } catch (error) {
                        signin.setLoading(false);
                        console.log(error)
                    }
                }
                if (text?.innerHTML === "01:00") text?.setHTMLUnsafe("00:59");
                else {
                    const num = Number(text?.innerHTML.split(":")[1]);
                    const newNum = num <= 10 ? `0${(num - 1)}` : (num - 1); // add 0 when second is less than 10
                    text?.setHTMLUnsafe(`${"00"}:${newNum}`);
                }
            }, 1000);
        }
        return () => {
            // Cleanup code to run when the component unmounts
            if (setIntervalForSeconds) clearInterval(setIntervalForSeconds);
        };
    }, [appState?.signin.situation])

    const handleResendCode = async () => {
        try {
            signin.setLoading(true);
            // const resetResult = await appState.signin.resetRecaptcha(); // it is not needed, Recaptcha is already reset (just after finishing the time for entering the code)
            const mobileNumber = login?.mobileNumber;
            if (mobileNumber) {
                const result = await appState.signin.loginWithPhoneNumberconfirmation(`+61${mobileNumber}`);
                if (result) {
                    const beforeSituation = appState?.signin.situation;
                    const newSituation = beforeSituation === SigninSituation.CodeExpiredForSignin ?
                        SigninSituation.EnterCodeForSignin : SigninSituation.EnterCodeForSignup;
                    signin.setSituation(newSituation);
                }
            }
            signin.setLoading(false);
        } catch (error) {
            signin.setLoading(false);
            console.log(error)
        }
    }
    return (
        <div className={styles.second_part}
        >
            {
                enterCodeSituation ?
                    <p><span className={styles.second} ref={second}>01:00</span>{" "}seconds until new message</p>
                    :
                    <Button className={styles.resend_code} onClick={handleResendCode}>Resend Code</Button>
            }
        </div>
    )
}
export default Second;